import styles from './PagesSpinner.module.scss'
import { useMemo } from 'react'
import { ID_MODAL_PORTAL } from '@/constants/general'
import ReactDOM from 'react-dom'
import classNames from 'classnames'
import { IClass } from '@/interfaces/general'
import YouchatSpinner from '@/components/Modal/Spinners/YouchatSpinner/YouchatSpinner'

type PagesSpinnerProps = IClass

const PagesSpinner = ({ className }: PagesSpinnerProps) => {
  const containerElement = useMemo(
    () => document.getElementById(ID_MODAL_PORTAL),
    []
  )

  if (!containerElement) {
    throw new Error(`Portal "${ID_MODAL_PORTAL}" not found`)
  }

  return ReactDOM.createPortal((
    <div className={classNames(styles.box, className)}>
      <YouchatSpinner />
    </div>
  ), containerElement)
}

export default PagesSpinner
